import type { ReactNode, SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

function Icon({ size = 18, children, ...rest }: IconProps & { children: ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...rest}
    >
      {children}
    </svg>
  );
}

export function LayoutDashboard(props: IconProps) {
  return (
    <Icon {...props}>
      <rect x="3" y="3" width="7" height="9" rx="1" />
      <rect x="14" y="3" width="7" height="5" rx="1" />
      <rect x="14" y="12" width="7" height="9" rx="1" />
      <rect x="3" y="16" width="7" height="5" rx="1" />
    </Icon>
  );
}

export function Cpu(props: IconProps) {
  return (
    <Icon {...props}>
      <rect x="5" y="5" width="14" height="14" rx="2" />
      <rect x="9" y="9" width="6" height="6" />
      <path d="M9 2v3M15 2v3M9 19v3M15 19v3M2 9h3M2 15h3M19 9h3M19 15h3" />
    </Icon>
  );
}

export function FolderKanban(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" />
      <path d="M9 12v4M13 10v6M17 13v3" />
    </Icon>
  );
}

export function ListTodo(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M10 6h11M10 12h11M10 18h11" />
      <path d="M3 6h.01M3 12h.01M3 18h.01" />
      <path d="M4.5 5.5l1 1 2-2" />
    </Icon>
  );
}

export function UserRound(props: IconProps) {
  return (
    <Icon {...props}>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20a8 8 0 0 1 16 0" />
    </Icon>
  );
}

export function Shield(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M12 3l8 3v6c0 5-3.5 8.5-8 9-4.5-.5-8-4-8-9V6l8-3z" />
    </Icon>
  );
}

export function Plug(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M9 2v6M15 2v6M7 8h10v3a5 5 0 0 1-10 0V8z" />
      <path d="M12 16v6" />
    </Icon>
  );
}

export function Cloud(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M7.5 18a4.5 4.5 0 0 1-.4-9 6 6 0 0 1 11.5 1.5A3.5 3.5 0 1 1 18 18H7.5z" />
    </Icon>
  );
}

export function Wrench(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M14.7 6.3a4 4 0 0 0-5.6 5.6L4 17l3 3 5.1-5.1a4 4 0 0 0 5.6-5.6l-2.4 2.4-2.2-2.2 2.6-2.2z" />
    </Icon>
  );
}

export function Landmark(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M3 10h18" />
      <path d="M5 10V19M10 10V19M14 10V19M19 10V19" />
      <path d="M3 19h18" />
      <path d="M12 3l9 7H3l9-7z" />
    </Icon>
  );
}

export function BarChart(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M4 19V5" />
      <path d="M4 19h16" />
      <path d="M8 16v-4M12 16V8M16 16v-6" />
    </Icon>
  );
}

export function ClipboardList(props: IconProps) {
  return (
    <Icon {...props}>
      <rect x="6" y="4" width="12" height="17" rx="2" />
      <path d="M9 4.5h6v2H9z" />
      <path d="M9 11h6M9 15h4" />
    </Icon>
  );
}
